export default __webpack_public_path__ + "e51f3c32ee1ee11fd8484c36ae15dae4.svg";